import { Tabs } from "antd";
import React, { useState, useEffect, useContext } from "react";
import { IoMdAddCircleOutline } from "react-icons/io";
import CarDetails from "./CarDetails";
import Specifications from "./Specifications";
import Equipments from "./Equipments";
import "./carform.scss";
import moment from "moment";
import {
  fetchBrands,
  fetchCarDetails,
  fetchCities,
  fetchDistricts,
  fetchModels,
  fetchPackages,
} from "../../stores/api_calls/carlists";
import UploadCarImages from "./UploadCarImages";
import PreviewCar from "./PreviewCar";
import { useLocation } from "react-router-dom";
import Kjur from "../../stores/utils/jwt";
import {
  validateProductForm,
  validateUpload,
} from "../../stores/helpers/productFormValidation";
import {
  fuelTypes,
  ownerIdTypes,
  vehicleTypes,
  usedCarCategories,
} from "../../contants/variables";
import { fetchUsers } from "../../stores/api_calls/users";
import { AccessContext } from "../../stores/contexts/accessContext";

const { TabPane } = Tabs;

const CarFormIndex = (props) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const [isEdit, setIsEdit] = useState(false);
  // const [roles,permissions] = useContext(AccessContext)
  const [cities, setCities] = useState({ loading: false, data: [] });
  const [districts, setDistricts] = useState({ loading: false, data: [] });
  const [brands, setBrands] = useState({ loading: false, data: [] });
  const [dealers, setDealers] = useState({ loading: false, data: [] });
  const [packages, setPackages] = useState([]);
  const [models, setModels] = useState({ loading: false, data: [] });
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [urlsHolder, setUrlsHolder] = useState([]);
  const [saleAdvisers, setSaleAdvisers] = useState([]);
  const [form, setForm] = useState({
    dealerId: ``,
    dealerFirstName: "",
    dealerLastName: "",
    dealerMobileNumber: "",
    dealerEmail: "",
    direct_seller: false,
    role: "",
    displayMobile: 0,
    enableInquiry: 0,
    packageId: "",
    isManualInput: 0,

    carName: "",
    plateNumber: "",
    askingPrice: 0,
    monthly_installment_price: 0,
    carBrand: "",
    carModel: "",
    city: "",
    district: "",
    vehicleType: "",
    registrationDate: null,
    manufacturedYear: "",
    color: "",
    mileage: "",
    numberOfOwners: "",
    roadTax: 0,
    categories: [],
    option_label_1: null,
    youtubeVideo: "",
    tiktokVideo: "",
    videoType: "youtube",
    localVideoUrl: null,

    isCommercialVehicle: "",
    isVerified: false,
    isSendEmail: false,

    productAgents: [],
    cityId: "",
    cityName: "",
    regionName: "",
    address: "",

    features: "",
    accessories: "",
    description: "",

    productTransmission: "",
    fuelType: "",
    engineCap: "",
    power: "",
    curbWeight: "",
    driveRange: 0,
    fuelConsumptionKilometer: 0,
    isHybrid: false,
    isElectric: false,

    condition: "Used",
    isRental: false,
    imageUrls: [],
    blueCardFile: null,
    inspectionReportFile: null,

    specifications: [],
    equipments: [],

    // omv: "",
    // arf: "",
    // coe: "",
    // coeExpiryDate: moment(),
    // coeLeftDate: null,
    // deregValue: "",
    // depreciationValue: "",

    // isOffPeak: false,
    // offPeakOption: 0,
    // vehicleNumber: "",
    // vehicleUnitNumber: "",
    // vehicleReferenceNumber: "",
    // vehicleRegistrationCardNumber: "",
  });
  const [enableTab, setEnableTab] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getCities();
    getBrands();
    getPackages();
    getDealers();

    if (location.pathname.includes("/edit")) {
      setIsEdit(true);
    }
  }, []);

  useEffect(() => {
    if (isEdit) {
      getCarDetails();
    }
  }, [isEdit]);

  useEffect(() => {
    if (form.carBrand) {
      // console.log(form.carBrand, form.carModel);
      setModels({ ...models, loading: true, data: [] });
      // setForm({ ...form, carModel: "" });
      getModels();
    } else {
      setModels({ ...models, loading: false, data: [] });
      setForm({ ...form, carModel: "" });
    }
  }, [form.carBrand]);
  useEffect(() => {
    if (form.city) {
      // console.log(form.carBrand, form.carModel);
      setDistricts({ ...districts, loading: true, data: [] });
      // setForm({ ...form, carModel: "" });
      getDistricts();
    } else {
      setModels({ ...districts, loading: false, data: [] });
      setForm({ ...form, district: "" });
    }
  }, [form.city]);

  useEffect(() => {
    if (!form.dealerId || !dealers?.data?.length) return;

    const dealer = dealers.data.find((d) => d._id === form.dealerId);

    if (!dealer) return;

    setForm((prev) => ({
      ...prev,
      dealerMobileNumber: dealer.user_contact_numbers
        ?.filter((el) => el.is_active)
        .map((el) => el.number),

      dealerEmail: dealer.user_contact_emails
        ?.filter((el) => el.is_active)
        .map((el) => el.email),

      role: dealer.user_role,
    }));
  }, [form.dealerId, dealers.data]);

  const getCarDetails = async () => {
    setIsLoading(true);
    const onGetCarDetails = fetchCarDetails(params.get("id"));
    onGetCarDetails
      .then((res) => {
        if (res.data.success) {
          const parsedData = res.data.data;
          //console.log(parsedData);
          setForm({
            ...form,
            id: parsedData._id,
            packageId: parsedData.selected_ads_id,

            dealerId: parsedData.advertisement_contact_details?._id ?? "",
            role:
              parsedData.advertisement_contact_details?.role_name ?? "Dealer",
            dealerEmail:
              parsedData.advertisement_contact_details?.user_contact_emails
                ?.email,
            dealerMobileNumber:
              parsedData.advertisement_contact_details?.user_contact_numbers
                ?.number,
            fullname: parsedData.advertisement_contact_details?.name,
            direct_seller:
              parsedData.advertisement_contact_details?.direct_seller,

            carName: parsedData.product_name,
            plateNumber: parsedData.car_plate_number,
            askingPrice: parsedData.product_price,
            monthly_installment_price:
              parsedData.monthly_installment_price ?? 0,
            carBrand: parsedData.product_brand?._id ?? "",
            carModel: parsedData.product_brand_model?._id ?? "",
            city: parsedData.city?._id ?? "",
            district: parsedData.district?._id ?? "",
            vehicleType: parsedData.vehicle_type,
            registrationDate:
              parsedData.registration_date === "N/A" ||
              !parsedData.registration_date
                ? null
                : parsedData.registration_date,
            manufacturedYear: parsedData.product_edition,
            color: parsedData.color,
            mileage: parsedData.product_mileage,
            numberOfOwners: parsedData.number_of_owners,
            roadTax: parsedData.road_tax ?? 0,
            categories: parsedData.categories || [],
            option_label_1: parsedData.option_label_1
              ? parsedData.option_label_1
              : null,
            youtubeVideo: parsedData.youtube_video,
            tiktokVideo: parsedData.tiktok_video,
            videoType:
              parsedData?.video_type != null
                ? parsedData?.video_type
                : "youtube",
            localVideoUrl: parsedData?.local_video_url,

            isCommercialVehicle: parsedData.is_commercial_vehicle,
            productAgents: parsedData?.product_agents ?? [],

            cityName: parsedData?.product_pickup_location?.city,
            regionName: parsedData?.product_pickup_location?.region_name,
            address: parsedData?.product_pickup_location?.street,

            features: parsedData.vehicle_features,
            accessories: parsedData.accessories,
            description: parsedData.product_description,

            productTransmission: parsedData.product_transmission,
            fuelType: parsedData.fuel_type,
            engineCap: parsedData.product_cc,
            power: parsedData.power,
            curbWeight: parsedData.curb_weight,
            driveRange: parsedData?.drive_range ?? 0,
            fuelConsumptionKilometer:
              parsedData?.fuel_consumption_kilometer ?? 0,
            isHybrid: parsedData.is_hybrid,
            isElectric: parsedData.is_electric,

            condition: parsedData.product_condition,
            isRental: parsedData.product_is_rental,
            imageUrls: parsedData.product_image_urls,
            blueCardFile: parsedData.blue_card_file,
            inspectionReportFile: parsedData.inspection_report_file,

            specifications: parsedData.specifications,
            equipments: parsedData.equipments,

            // omv: parsedData.omv,
            // arf: parsedData.arf,
            // coe: parsedData.coe,
            // coeExpiryDate: parsedData.coe_expiry_date,
            // deregValue: parsedData.dereg_value,
            // depreciationValue: parsedData.depreciation_value,
            // isOffPeak: parsedData.is_off_peak_car,
            // vehicleNumber: parsedData.product_vehicle_number,
            // vehicleUnitNumber: parsedData.product_vehicle_unit_number,
            // vehicleReferenceNumber: parsedData.product_reference_number,
            // vehicleRegistrationCardNumber:
            //   parsedData.product_vehicle_registration_card_number,
          });

          // setSaleAdvisers(parsedData?.advertisement_contact_details.agents);
          let defaultAgents = [];
          if (parsedData?.advertisement_contact_details?.agents) {
            defaultAgents =
              parsedData?.advertisement_contact_details.agents?.filter(
                (item) => item && item?.fullName && item?.fullName !== "",
              );
          }
          let sortingAgents = [];
          defaultAgents.map((item, i) => {
            let findAgent = parsedData?.product_agents?.filter(
              (agent) => agent?.fullName == item.fullName,
            );

            sortingAgents.push({
              fullName: item.fullName,
              contactNumber: item.contactNumber,
              sorting: findAgent.length > 0 ? findAgent[0].sorting : i + 1,
            });
          });
          setSaleAdvisers(sortingAgents);
          setIsLoading(false);
        }
      })
      .catch((e) => console.log(e));
  };

  const getDealers = () => {
    setDealers({ ...dealers, loading: true });
    const pagination = {
      page: 1,
      limit: 100000,
      keyword: "",
      // roleIds: roles.filter((el)=>roleNames.includes(el.name)).map((el)=>el._id),
      roleIds: ["619e5d55e7040000a2007b08", "619e5d67e7040000a2007b09"],
      isVerified: true,
    };

    const users = fetchUsers(pagination);
    users
      .then((res) => {
        if (res.data.success) {
          setDealers({ ...dealers, loading: false, data: res.data.data });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const getCities = () => {
    setCities({ ...cities, loading: true });
    const onGetCities = fetchCities();
    onGetCities
      .then((res) => {
        if (res.data.success) {
          setCities({ ...cities, loading: false, data: res.data.data });
          if (isEdit) {
            res.data.data.forEach((city) => {
              setForm({ ...form, cityId: city._id });
            });
          }
        }
      })
      .catch((e) => console.log(e));
  };

  const getBrands = () => {
    const pagination = {
      page: 1,
      limit: 10000,
    };
    setBrands({ ...brands, loading: true });
    const onGetBrands = fetchBrands(pagination);
    onGetBrands
      .then((res) => {
        if (res.data.success) {
          setBrands({ ...brands, loading: false, data: res.data.data });
        }
      })
      .catch((e) => console.log(e));
  };

  const getModels = () => {
    const onGetModels = fetchModels(form.carBrand);
    onGetModels
      .then((res) => {
        if (res.data.success) {
          setModels({ ...models, loading: false, data: res.data.data });
        }
      })
      .catch((e) => console.log(e));
  };
  const getDistricts = () => {
    const onGetDistricts = fetchDistricts(form.city);
    onGetDistricts
      .then((res) => {
        if (res.data.success) {
          setDistricts({ ...districts, loading: false, data: res.data.data });
        }
      })
      .catch((e) => console.log(e));
  };
  const getPackages = () => {
    const packageType = "used";
    const packages = fetchPackages(packageType);
    packages
      .then((res) => {
        if (res.data.success) {
          setPackages(res.data.data);
        }
      })
      .catch((e) => console.log(e));
  };

  return (
    <div className="form-table-container">
      <div className={`table-title-icon ${!isEdit ? "add" : "edit"}`}>
        <IoMdAddCircleOutline />
      </div>
      <p className={`table-title-text ${!isEdit ? "add" : "edit"}`}>
        {!isEdit ? "Create Car Ad" : `Edit Car Ad`}
      </p>

      <div className="form-body-container">
        <Tabs size="large">
          <TabPane tab="Car Details Form" key="1">
            <CarDetails
              form={form}
              setForm={setForm}
              cities={cities}
              districts={districts}
              brands={brands}
              models={models}
              dealers={dealers}
              packages={packages}
              isEdit={isEdit}
              vehicleTypes={vehicleTypes}
              usedCarCategories={usedCarCategories}
              fuelTypes={fuelTypes}
              saleAdvisers={saleAdvisers}
            />
          </TabPane>
          <TabPane
            tab="Specifications"
            key="2"
            disabled={!validateProductForm(form)}
          >
            <Specifications
              form={form}
              specifications={form.specifications}
              setForm={setForm}
              isEdit={isEdit}
              fuelTypes={fuelTypes}
            />
          </TabPane>
          <TabPane
            tab="Equipments"
            key="3"
            disabled={!validateProductForm(form)}
          >
            <Equipments
              form={form}
              equipments={form.equipments}
              setForm={setForm}
              isEdit={isEdit}
            />
          </TabPane>
          <TabPane
            tab="Upload Images"
            key="4"
            disabled={!validateProductForm(form)}
          >
            <UploadCarImages
              isEdit={isEdit}
              form={form}
              setForm={setForm}
              selectedFiles={selectedFiles}
              setSelectedFiles={setSelectedFiles}
              urlsHolder={urlsHolder}
              setUrlsHolder={setUrlsHolder}
            />
          </TabPane>
          <TabPane
            tab="Car Ad Preview"
            key="5"
            disabled={
              !validateProductForm(form) ||
              !validateUpload(selectedFiles, form.imageUrls)
            }
          >
            <PreviewCar
              isEdit={isEdit}
              form={form}
              selectedFiles={selectedFiles}
            />
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
};

export default CarFormIndex;
